import {
  TrendingUp,
  TrendingDown,
  DollarSign,
  Calendar,
  Users,
  Building2,
} from "lucide-react";

export default function StatisticsOverview({
        ingresos_total_aprobado,
        ingresos_total_pendiente,
        reservas_activas,
        tasa_cancelacion,
        huespedes_total,
        comisiones_total,
        alojamientos_activos,
}: any) {
  const stats = [
    {
      title: "Ingresos Totales",
      value: `$${ingresos_total_aprobado}`,
      change: "+12.5%",
      trend: "up",
      icon: DollarSign,
      description: "vs. mes anterior",
    },
    {
      title: "Reservas Activas",
      value: `${reservas_activas}`,
      change: "+8.2%",
      trend: "up",
      icon: Calendar,
      description: "este mes",
    },
    {
      title: "Huéspedes Totales",
      value: `${huespedes_total}`,
      change: "-2.1%",
      trend: "down",
      icon: Users,
      description: "vs. mes anterior",
    },
    {
      title: "Alojamientos Activos",
      value: alojamientos_activos,
      change: "+4.3%",
      trend: "up",
      icon: Building2,
      description: "en plataforma",
    },
    {
      title: "Comisiones",
      value: `$${comisiones_total}`,
      change: "+15.8%",
      trend: "up",
      icon: TrendingUp,
      description: "este mes",
    },
    {
      title: "Tasa de Cancelación",
      value: `${tasa_cancelacion}%`,
      change: "-0.8%",
      trend: "up",
      icon: TrendingDown,
      description: "vs. mes anterior",
    },
  ];

  console.log({ingresos_total_pendiente});
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white p-6 rounded-lg border shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="flex flex-row items-center justify-between space-y-0 pb-2">
            <h3 className="text-sm font-medium text-gray-600">{stat.title}</h3>
            <stat.icon className="h-4 w-4 text-gray-400" />
          </div>
          <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
          <div className="flex items-center gap-1 text-xs text-gray-600 mt-1">
            <span
              className={`flex items-center gap-1 ${
                stat.trend === "up" ? "text-green-600" : "text-red-600"
              }`}
            >
              {stat.trend === "up" ? (
                <TrendingUp className="h-3 w-3" />
              ) : (
                <TrendingDown className="h-3 w-3" />
              )}
              {stat.change}
            </span>
            <span>{stat.description}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
